export const SAW_TABLET_ASSET_NAME = "20th Street Saw";
export const SAW_TABLET_PERMISSION = "ui.pages.saw-tablet";

export interface SawTabletTabProps {
	assetId: number;
}
